<template>
    <div class="simple-form flex col-2">
        <div class="content-caption dashed">
            <span>基本属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构名称</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.name || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构状态</label>
            </div>
            <div class="form-value">
                <span>{{ orgStateMap[comInfo.state] || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构类型</label>
            </div>
            <div class="form-value">
                <span>{{ orgTypeMap[comInfo.orgType] || '' }}</span>
            </div>
        </div>
        <div class="form-group center" v-if="comInfo.orgType == 1">
            <div class="form-label">
                <label>业务单元类型</label>
            </div>
            <div class="form-value">
                <span>{{ bizUnitTypeMap[comInfo.bizUnitType] }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>是否门店</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.shopFlag ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构标签</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.tagName || '' }}</span>
            </div>
        </div>
        <!--业务单元属性 unitBizAttr-->
        <div class="content-caption dashed">
            <span>业务单元属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>经营区域</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.bizAreaName || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>经营业态</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.bizFormName || '' }}</span>
            </div>
        </div>
        <div class="form-group center" v-if="comInfo.orgType == 1">
            <div class="form-label">
                <label>管理区域</label>
            </div>
            <div class="form-value">
                <span v-if="comInfo.mgmtSmlAreaName != null && comInfo.mgmtSmlAreaName != ''">{{ (comInfo.mgmtBigAreaName || '') + '/' + (comInfo.mgmtSmlAreaName || '') }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>开启岗位组织</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.postOrgEnabled ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>开启岗位商品分类</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.postGoodsCatEnabled ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>开启设备分类分组</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.postDevcGrpEnabled ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>开启岗位管理区域</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.postMgmtAreaEnabled ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center" v-if="!comInfo.shopFlag">
            <div class="form-label">
                <label>开启下级机构标签</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.postSubShopTagFilterEnabled ? '是' : '否' }}</span>
            </div>
        </div>
        <!--交易业务属性 tradeBizAttr-->
        <div class="content-caption dashed">
            <span>交易业务属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>独立核算</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.indepenAcnt ? '是' : '否' }}</span>
            </div>
        </div>
        <!--财务业务属性 finacBizAttr-->
        <div class="content-caption dashed">
            <span>财务业务属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>实体公司编码</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.realComCode || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>成本中心编码</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.costCenterCode || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>利润中心编码</label>
            </div>
            <div class="form-value width-2x">
                <span>{{ comInfo.prftCenterCode || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>核算模型</label>
            </div>
            <div class="form-value width-2x">
                <span>{{ comInfo.acntModelName || '' }}</span>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>账外资产业务属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>允许调出</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.devcAllotOutAllowed ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>允许导入</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.devcImportAllowed ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>业务冻结</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.devcBizFrozen ? '是' : '否' }}</span>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>账内资产业务属性</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>允许调出</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.assetAllotOutAllowed ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>允许导入</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.assetImportAllowed ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>业务冻结</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.assetBizFrozen ? '是' : '否' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'

    import retailerApi from '../../api/retailer'
    import finac2Api from '../../api/finac2'

    export default {
        name: 'swb-com-detail',
        desc: '公司信息-详情',
        props: {
            comId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                comInfo: {},
                orgStateMap: getEnumMap('orgState', 'value2text'),
                orgTypeMap: getEnumMap('orgType', 'value2text'),
                bizUnitTypeMap: getEnumMap('bizUnitType', 'value2text'),
                // 核算模型信息
                fiscalAcntModelDef: null
            }
        },
        created: function () {
            this.getFiscalAcntModelDef();
        },
        methods: {
            // 获取核算模型信息
            getFiscalAcntModelDef: function () {
                let self = this;
                finac2Api.getFiscalAcntModelDefByComId({comId: self.comId}, function (result) {
                    if (result.type == 'info') {
                        let fiscalAcntModelDef = result.data;
                        self.fiscalAcntModelDef = Utils.merge({}, fiscalAcntModelDef);
                        self.getComInfo(self.comId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerCom(postData, function (result) {
                    theLoad.close();
                    if (result.type == 'info') {
                        let comInfo = result.data || {};
                        let fiscalAcntModelDef = self.fiscalAcntModelDef || {};
                        if (!Utils.isNoB(fiscalAcntModelDef) && fiscalAcntModelDef.id > 0) {
                            comInfo.acntModelName = fiscalAcntModelDef.name;
                        }
                        self.comInfo = Utils.merge({}, comInfo);
                    } else if (result.type == 'error') {
                        MsgBox.error(result.message, result.errid);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComDetail.vue